<template>
  <v-card class="datetime-field d-flex align-center" :width="320" tile flat>
    <div class="caption grey--text text--darken-2 mr-3">日付範囲</div>
    <v-btn small @click="dialog = true">{{ dateRangeText }}</v-btn>
    <v-dialog v-model="dialog" width="340">
      <v-card>
        <v-card tile color="primary" class="text-center py-4" dark>
          <div class="caption mb-2">日付範囲を選択してください</div>
          <div class="font-weight-bold">{{ dateRangeText }}</div>
        </v-card>
        <v-date-picker
          v-model="dates"
          range
          full-width
          :max="maxDate"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
          no-title
        />
        <v-card-actions>
          <v-btn text @click="reset()" color="primary">リセット</v-btn>
          <v-spacer />
          <v-btn @click="save()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import moment from "moment";
export default {
  name: "ChronologyDateRange",
  components: {
    //
  },

  data() {
    return {
      dialog: false,
      dates: [],
      maxDate: undefined
    };
  },

  computed: {
    dateRangeText() {
      if (this.dates.length === 0) return "未設定";
      const arr = [...this.dates];
      arr.sort();
      return arr.join(" ~ ").replaceAll("-", "/");
    }
  },

  created() {
    const now = moment().local();
    this.maxDate = now.format("YYYY-MM-DD");
  },

  methods: {
    save() {
      this.dialog = false;
      this.$emit("change", this.dates);
    },
    reset() {
      this.dates = [];
      this.save();
    }
  }
};
</script>
<style lang="scss">
//
</style>
